const STATUS = {
  online: { label: 'Online', color: '#15803d', bg: '#dcfce7' },
  offline: { label: 'Offline', color: '#b91c1c', bg: '#fee2e2' },
  pending: { label: 'Pending', color: '#78716c', bg: '#f1f5f9' },
  unknown: { label: 'Unknown', color: '#a16207', bg: '#fef3c7' },
};

export function StatusBadge({ status }) {
  const s = STATUS[status] || STATUS.unknown;
  return (
    <span style={{
      fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em',
      color: s.color, background: s.bg, padding: '4px 10px', borderRadius: 999,
    }}>
      {s.label}
    </span>
  );
}

export function MetricCard({ label, value, sub }) {
  return (
    <div style={{
      padding: '1rem 1.1rem',
      borderRadius: 16,
      border: '1px solid #f1f5f9',
      background: '#fff',
    }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>
        {label}
      </div>
      <div style={{ fontSize: 26, fontWeight: 800, color: '#0f0f1a', letterSpacing: '-0.02em' }}>
        {value}
      </div>
      {sub && <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>{sub}</div>}
    </div>
  );
}

export function ChartCard({ title, children, value }) {
  return (
    <div style={{
      padding: '1rem 1.1rem',
      borderRadius: 16,
      border: '1px solid #f1f5f9',
      background: '#fff',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: '#64748b' }}>{title}</div>
        {value != null && value !== '' && (
          <div style={{ fontSize: 12, fontWeight: 700, color: '#0f0f1a', fontVariantNumeric: 'tabular-nums' }}>{value}</div>
        )}
      </div>
      {children}
    </div>
  );
}

export function ServiceRow({ name, online, detail }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
      padding: '0.75rem 0.9rem', borderRadius: 12, border: '1px solid #f1f5f9', background: '#fafafa',
    }}>
      <div>
        <div style={{ fontWeight: 700, fontSize: 14, color: '#0f0f1a' }}>{name}</div>
        {detail && <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{detail}</div>}
      </div>
      <span style={{
        width: 8, height: 8, borderRadius: '50%',
        background: online ? '#15803d' : '#b91c1c', flexShrink: 0,
      }} />
    </div>
  );
}

export function InfoRow({ label, value }) {
  return (
    <div style={{ padding: '0.75rem 0.9rem', borderRadius: 12, border: '1px solid #f1f5f9', background: '#fafafa' }}>
      <div style={{ fontSize: 10, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{label}</div>
      <div style={{ fontSize: 14, fontWeight: 600, color: '#0f0f1a', marginTop: 4, wordBreak: 'break-word' }}>{value || '—'}</div>
    </div>
  );
}
